import { getFormData } from '../../../../../utils/formatters';
import { EditableQuestion, Questionnaire, Section } from '../../../types';
import { withoutClearedDefaultToggle } from '../QuestionViewerEditor/QuestionEditor/components/StructuredInputEditor/utils';

export const groupQuestionsBySections = (questions: EditableQuestion[]): Section[] => {
  // Group questions by their section number
  const sectionsMap = questions.reduce((acc: any, question: EditableQuestion) => {
    const sectionNumber = question.section || 1; // Default to section 1 if not specified

    if (!acc[sectionNumber]) {
      acc[sectionNumber] = {
        section: sectionNumber,
        questions: []
      };
    }

    acc[sectionNumber].questions.push(question);
    return acc;
  }, {});

  // Sort sections by section number and questions within each section by position
  return Object.values(sectionsMap)
    .sort((a: any, b: any) => a.section - b.section)
    .map((section: any) => ({
      ...section,
      questions: section.questions.sort((a: EditableQuestion, b: EditableQuestion) => a.position - b.position)
    }));
};

export const getQuestionnaireFormData = (questionnaire: Questionnaire) => {
  const preparedQuestionnaire = convertQuestionnaireToHaveNoNumberAnswers(questionnaire);
  return getFormData(preparedQuestionnaire);
};

export const convertQuestionnaireToHaveNoNumberAnswers = (questionnaire: Questionnaire) => {
  const updatedSections = questionnaire.sections.map(mapSection);

  return {
    ...questionnaire,
    sections: updatedSections
  };
};

const mapSection = (section: Section) => {
  return {
    ...section,
    questions: section.questions.map(mapQuestion)
  };
};

const mapQuestion = (question: EditableQuestion) => {
  return {
    ...withoutClearedDefaultToggle(question),
    type: question.type === 'single_selection' ? 'single_radio_selection' : question.type,
    answers: question.answers?.map(mapAnswer)
  };
};

const mapAnswer = (answer: any) => {
  return {
    ...answer,
    value: getNumberAsStringOrReturnValue(answer.value)
  };
};

const getNumberAsStringOrReturnValue = (value?: string | number | null) => {
  return Number.isNaN(Number(value)) ? value : `"${value}"`;
};
